<template>
  <!-- 历史版本查看弹窗 -->
  <dialogModel
    :visible="dialogVisible"
    :title="dataObj.name || '查看协议'"
    :footer="false"
    width="1000px"
    @handleClose="handleClose"
  >
    <div class="view-body">
      <p class="time">版本：{{ dataObj.version }}</p>
      <p class="time">时间：{{ formatDate(dataObj.createTime) }}</p>
      <div class="view-content" v-html="dataObj.fullText"></div>
    </div>
  </dialogModel>
</template>

<script>
export default {
  props: {
    dialogVisible: {},
    dataObj: {}, // 协议数据
  },
  components: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    formatDate(time) {
      if (!time) return "";
      return String(time).replace("T", " ").slice(0, 10);
    },
  },
};
</script>

<style scoped lang="less">
.view-body {
  width: 100%;
  box-sizing: border-box;
  word-break: break-word;
  overflow-wrap: break-word;
  .time {
    text-align: right;
    font-size: 14px;
    color: #666666;
    margin-bottom: 5px;
  }
  /deep/.view-content p {
    font-size: 14px;
    color: #666666;
    letter-spacing: 1.5px;
    line-height: 30px;
    font-weight: 400;
    text-indent: 30px;
  }
  /deep/.view-content img {
    max-width: 100%;
    width: auto;
    height: auto;
    max-height: 250px;
    margin: 0 auto !important;
    display: block;
    border: 1px solid #b7b7b7;
  }
  /deep/.view-content table {
    max-width: 100%;
    overflow-x: auto;
    display: block;
  }
}
</style>
